import { render } from "./VInfoList.vue?vue&type=template&id=236b98db"
const script = {}

import "./VInfoList.vue?vue&type=style&index=0&id=236b98db&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__